import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TcardsBrandLogo from '../TcardsBrandLogo';
import { LanguageSwitcher } from '../LanguageSwitcher';
import { TCARDS_HOME_URL } from '../miniwebsite/miniWebsitePaths';
import { TEMPLATES_CHOOSE_URL } from './digitalCardRoutes';

type Props = {
  activePath?: string;
};

export const DigitalCardNav: React.FC<Props> = ({ activePath }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const links = [
    { to: '/digital-card', label: t('dcl_nav_digital_card', { defaultValue: 'Digital Card' }) },
    { to: '/templates', label: t('dcl_nav_templates', { defaultValue: 'Templates' }) },
    { to: '/digital-card#pricing', label: t('dcl_nav_pricing', { defaultValue: 'Pricing' }) },
    { to: '/contact', label: t('dcl_nav_contact', { defaultValue: 'Contact Us' }) },
  ];

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  return (
    <header className="dcl-nav">
      <TcardsBrandLogo
        href={TCARDS_HOME_URL}
        className="dcl-nav-brand"
        tagline={t('dcl_nav_tagline', { defaultValue: 'Digital Business Card' })}
        taglineClassName="dcl-nav-tagline"
        size={36}
      />
      <nav className="dcl-nav-links" aria-label="Main">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="dcl-nav-link"
            style={activePath === l.to ? { color: '#2563EB', fontWeight: 700 } : undefined}
          >
            {l.label}
          </Link>
        ))}
      </nav>
      <div className="dcl-nav-row">
        <div className="dcl-nav-actions">
          <LanguageSwitcher compact className="dcl-lang-select" />
          <Link to="/auth?login=1" className="dcl-btn dcl-btn--ghost dcl-btn--sm">
            {t('dcl_nav_sign_in', { defaultValue: 'Sign In' })}
          </Link>
          <Link to={TEMPLATES_CHOOSE_URL} className="dcl-btn dcl-btn--dark dcl-btn--sm dcl-btn--pill">
            {t('dcl_nav_get_started', { defaultValue: 'Get Started' })}
          </Link>
        </div>
        <button
          type="button"
          className="dcl-menu-btn"
          aria-label={open ? t('dcl_nav_close_menu', { defaultValue: 'Close menu' }) : t('dcl_nav_open_menu', { defaultValue: 'Open menu' })}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? '✕' : '☰'}
        </button>
      </div>
      <div className={`dcl-nav-mobile${open ? ' dcl-nav-mobile--open' : ''}`}>
        <div className="dcl-nav-mobile-lang">
          <LanguageSwitcher className="dcl-lang-select dcl-lang-select--block" />
        </div>
        {links.map((l) => (
          <Link key={l.to} to={l.to} className="dcl-nav-link" onClick={() => setOpen(false)}>
            {l.label}
          </Link>
        ))}
        <Link to="/auth?login=1" className="dcl-btn dcl-btn--ghost dcl-btn--block" onClick={() => setOpen(false)}>
          {t('dcl_nav_sign_in', { defaultValue: 'Sign In' })}
        </Link>
        <Link to={TEMPLATES_CHOOSE_URL} className="dcl-btn dcl-btn--dark dcl-btn--block dcl-btn--pill" onClick={() => setOpen(false)}>
          {t('dcl_nav_get_started', { defaultValue: 'Get Started' })}
        </Link>
      </div>
    </header>
  );
};

export default DigitalCardNav;
